module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-dialog', {
    attrs: {
      "width": "550",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogConfirmaCadastro),
      callback: function($$v) {
        _vm.dialogConfirmaCadastro = $$v
      },
      expression: "dialogConfirmaCadastro"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Confirma o cadastro da ação de\n        extensão?")]), _vm._v(" "), (_vm.cursoOuEvento && _vm.registroTardio) ? _c('div', [_c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n          A submissão de uma proposta de ação retroativa deve ser acompanhada, obrigatoriamente, do relatório da\n          respectiva ação.\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirmaCadastro = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.criarNovoProjeto()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "required": "",
      "rules": _vm.tituloRules,
      "max-height": "400",
      "counter": "150"
    },
    model: {
      value: (_vm.projeto.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "titulo", $$v)
      },
      expression: "projeto.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação primária",
      "items": _vm.listaClassificacaoPrimaria,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "readonly": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.classificacaoPrimaria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "classificacaoPrimaria", $$v)
      },
      expression: "projeto.classificacaoPrimaria"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação secundária",
      "items": _vm.listaClassificacaoSecundaria,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    on: {
      "change": function($event) {
        return _vm.limparDataConclusaoSemLimite()
      }
    },
    model: {
      value: (_vm.projeto.classificacaoSecundaria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "classificacaoSecundaria", $$v)
      },
      expression: "projeto.classificacaoSecundaria"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "tipoPublico", $$v)
      },
      expression: "projeto.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Público-alvo estimado",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "publicoAlvo", $$v)
      },
      expression: "projeto.publicoAlvo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 44194) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do curso",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [(_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 44195) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária da oficina",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [(_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do evento",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [((_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 39733)) ? _c('v-checkbox', {
    attrs: {
      "value": true
    },
    on: {
      "change": _vm.onChangeDataSemLimite
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Essa é uma ação contínua, sem data limite")])]
      },
      proxy: true
    }], null, false, 3659365439),
    model: {
      value: (_vm.dataConclusaoSemLimite),
      callback: function($$v) {
        _vm.dataConclusaoSemLimite = $$v
      },
      expression: "dataConclusaoSemLimite"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataInicio", $$v)
      },
      expression: "projeto.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão",
      "rules": _vm.dataConclusaoRules,
      "disabled": _vm.dataConclusaoSemLimite
    },
    model: {
      value: (_vm.projeto.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataConclusao", $$v)
      },
      expression: "projeto.dataConclusao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave01),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave01", $$v)
      },
      expression: "projeto.palavraChave01"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave02),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave02", $$v)
      },
      expression: "projeto.palavraChave02"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave03),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave03", $$v)
      },
      expression: "projeto.palavraChave03"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave04),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave04", $$v)
      },
      expression: "projeto.palavraChave04"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo",
      "required": "",
      "rules": _vm.resumoRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000"
    },
    model: {
      value: (_vm.projeto.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "resumo", $$v)
      },
      expression: "projeto.resumo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": true
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "justify"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.termoCompromissoTexto) + "\n                      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.aceiteTermoCompromisso),
      callback: function($$v) {
        _vm.aceiteTermoCompromisso = $$v
      },
      expression: "aceiteTermoCompromisso"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || !_vm.aceiteTermoCompromisso
    },
    on: {
      "click": function($event) {
        return _vm.abreDialogCadastroAcaoExtensao()
      }
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d752936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/novo-projeto.vue
// module id = 431
// module chunks = 0